import {ChangeDetectorRef, Component} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ElementRef} from '@angular/core';
import {SubFormComponent} from '../../_subform';
import {EducationLevelProvider} from '@providers/education-level/education-level.provider';

/*
* Блок данных об образовании специалиста
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-education',
    templateUrl: './specialist-form-fields-education.component.html'
})
export class SpecialistFormFieldsEducationComponent extends SubFormComponent {

    public formGroupTemplate = this._fb.group({
        // Образование
        education_level_id: [''], // Уровень образования
        institute: [''], // Образовательное учреждение
        education_speciality: [''], // Специальность
        file_education: this._fb.group({ // Файл скана диплома
            file_id: [''],
            file_url: ['']
        }),
        education_additional: this._fb.array([]), // Дополнительное образование
    });

    constructor(public elementRef: ElementRef,
                private changeDetectionRef: ChangeDetectorRef,
                public educationLevelList: EducationLevelProvider,
                private _fb: FormBuilder) {
        super();
    }
}
